function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.95811 10.4091C5.04694 10.4091 5.77066 10.7883 6.09014 11.0024C6.20098 11.0636 6.54002 11.2471 6.61174 11.2532V2.00547C6.18794 1.2654 4.9361 0.666016 3.64515 0.666016C2.02168 0.666016 0.639446 1.54675 0.333008 2.14002V10.7761C0.333008 11.1798 0.580767 11.3327 0.893725 11.3327C1.13496 11.3327 1.30448 11.2532 1.46096 11.1308C1.84564 10.8067 2.75192 10.4091 3.95811 10.4091ZM10.0412 10.4091C11.254 10.4091 12.1472 10.8067 12.5449 11.1308C12.6949 11.2471 12.8579 11.3327 13.0991 11.3327C13.4121 11.3327 13.6663 11.1798 13.6663 10.7761V2.14002C13.3599 1.54675 11.9777 0.666016 10.3542 0.666016C9.06324 0.666016 7.81141 1.2654 7.39413 2.00547V11.2654C7.46585 11.2593 7.79837 11.0697 7.91573 11.0024C8.23521 10.7883 8.95893 10.4091 10.0412 10.4091Z",
  fill: "white"
});

function SvgIconOpenBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenBook);
export default __webpack_public_path__ + "static/media/icon-open-book.9d46a4a2.svg";
export { ForwardRef as ReactComponent };